import { LOADING_RELATORIOS, SET_GERAR_RELATORIO_USU_DELEGACAO, SET_USU_DELEGACAO_HIST } from './mutations-types'
import { ApiGerarRelatorioUsuDelegacao, ApiObterUsuDelegacaoHist } from '@/api'

export const ActionUsuDelegacaoHist = async ({ commit }, filtros, loading) => {
   await ApiObterUsuDelegacaoHist(filtros)
      .then((response) => {
         commit(LOADING_RELATORIOS, loading)
         commit(SET_USU_DELEGACAO_HIST, response)
         commit(LOADING_RELATORIOS, loading)
      })
      .catch(() => {
         commit(LOADING_RELATORIOS, loading)
         commit(SET_USU_DELEGACAO_HIST, null)
         commit(LOADING_RELATORIOS, loading)
      })
}

export const ActionsGerarRelatorioUsuDelegacao = async ({ commit }, filtros) =>
   await ApiGerarRelatorioUsuDelegacao(filtros)
      .then((response) => {
         commit(SET_GERAR_RELATORIO_USU_DELEGACAO, response)
      })
      .catch(() => commit(SET_GERAR_RELATORIO_USU_DELEGACAO, null))
